import { Component, Input, OnInit, DestroyRef, inject} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { UpdateEventInput } from '@app/models/event.model'
import { ApiDataResponse } from '@app/models/others.model'
import { TableColumnConfig, TableConfig } from '@app/models/shared.model'
import { EventsService } from '@app/modules/culture/events/services/events.service'
import { CommonService } from '@app/shared/services/common.service'
import { DateService } from '@app/shared/services/date.service'
import { MessageService } from 'primeng/api'


@Component({selector: 'app-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
  standalone: false,
})
export class TableCellComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  /** Table config */
  @Input() tableConfig: TableConfig

  /** Table row */
  @Input() row: any

  /** Current column config */
  @Input() col: TableColumnConfig

  /** Function for use for get data like labels etc... */
  @Input() labelCallbackFunction: (args: any) => any

  /** Icon callback function */
  @Input() iconCallbackFunction: (args: any) => any

  /** Is the row typeof group */
  @Input() isRowGroup: boolean

  /** Events import tickets dictionary to save event id and link and loading state to import tickets state management */
  eventsImportTicketsLinkKeyValue: Map<any, { link: string; loading?: boolean }> = new Map<any, { link: string; loading?: boolean }>()


  constructor(public commonService: CommonService, private messageService: MessageService, private eventService: EventsService, public dateService: DateService) {}

  ngOnInit(): void {
    // Init event import tickets link key value for use
    if (this.tableConfig.columnsConfig.find((v) => v.type == 'uploader'))
      this.tableConfig.data?.forEach((obj: any) => {
        this.eventsImportTicketsLinkKeyValue.set(obj.id, {
          link: '',
          loading: false,
        })
      })
  }


  /**
   * Return
   * @param remainedData
   */
  remainedDataHasValue(remainedData: any, key: string) {
    if (key == 'time_limitations') return remainedData?.length && remainedData.includes('hours')
    return remainedData?.length ? true : false
  }

  /**
   * Get import tickets link for event
   * @param id Event id
   * @returns Link
   */
  getImportTicketsLinkForEvent(id: any) {
    if (this.eventsImportTicketsLinkKeyValue.get(id)) {
      return this.eventsImportTicketsLinkKeyValue.get(id)!.link
    }
    return ''
  }

  /**
   * Change import tickets state
   * @param idEvent id
   * @param link Link
   */
  changeImportTicketsState(id: any, link: string) {
    this.eventsImportTicketsLinkKeyValue.set(id, { link: link })
  }

  /**
   * Import tickets on click event, update event tickets
   * @param id Event id
   */
  importTicketsOnClick(event: any, e: Event) {
    e.preventDefault()
    this.eventsImportTicketsLinkKeyValue.get(event.id)!.loading = true
    const eventToUpdate = {
      id: event.id,
      client_id: event.client_id,
      tickets_url: this.getImportTicketsLinkForEvent(event.id),
    }

    this.eventService
      .update(eventToUpdate)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: ApiDataResponse<UpdateEventInput>) => {
        if (data.success) {
          this.eventsImportTicketsLinkKeyValue.get(event.id)!.loading = false
          this.messageService.add({
            severity: 'success',
            icon: 'pi pi-check-circle color-success',
            summary: 'Import tickets success',
          })

          this.eventsImportTicketsLinkKeyValue.set(event.id, { link: '' })
        } else {
          this.eventsImportTicketsLinkKeyValue.get(event.id)!.loading = false
          this.eventsImportTicketsLinkKeyValue.get(event.id)!.link = ''

          this.messageService.add({
            severity: 'error',
            summary: 'Import tickets',
            detail: data.errorText,
          })
        }
      })
  }

  /**
   * Get loading link by event id
   * @param id
   * @returns
   */
  loadingLink(id: any) {
    return this.eventsImportTicketsLinkKeyValue.get(id)!.loading
  }

  avatarGroupData(row: any, col: TableColumnConfig) {
    return row[col.name].map((v: any) => Array.from(v.first_name)[0] + '' + Array.from(v.last_name)[0])
  }
}
